import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CanvasesCategoriesTest } from '../../pages/canvases/categories/Test';
import { Grid, Cell } from 'react-foundation';
import { FaInfoCircle } from 'react-icons/fa';

export default function DemoCanvasCompleted() {
  const navigate = useNavigate();
  const [checkboxStates, setCheckboxStates] = useState({});

  const demoNodes = [
    {
      id: 'category-node-1',
      type: 'categoryNode',
      position: { x: 400, y: 200 },
      data: { 
        value: 'Work-Life Balance Discussion',
        locked: true
      }
    },
    {
      id: 'why-node-1',
      type: 'whyNode',
      position: { x: 200, y: 350 },
      data: { 
        value: 'Team members are reporting increased stress and burnout due to heavy workloads and unclear boundaries between work and personal time.',
        locked: true
      }
    },
    {
      id: 'impact-node-1',
      type: 'impactNode',
      position: { x: 600, y: 350 },
      data: { 
        value: 'Decreased productivity, higher turnover rates, and negative impact on team morale and well-being.',
        locked: true
      }
    }
  ];

  const handleCheckboxChange = (actionId, isChecked) => {
    setCheckboxStates(prev => ({
      ...prev,
      [actionId]: isChecked
    }));
  };

  useEffect(() => {
    document.title = 'Forward Together - Demo Canvas Completed';

    const overrideBackButton = () => {
      const backButton = document.querySelector('#page-navigation-button--go-back');
      if (backButton) {
        backButton.href = '#';
        backButton.onclick = (e) => {
          e.preventDefault();
          navigate('/demo/conversations');
        };
      }

      const dropdownBackButton = document.querySelector('.canvas-actions[href="/pages/how-to-use-this-tool"]');
      if (dropdownBackButton) {
        dropdownBackButton.href = '#';
        dropdownBackButton.onclick = (e) => {
          e.preventDefault();
          navigate('/demo/conversations');
        };
      }
    };

    const timer = setTimeout(overrideBackButton, 500);
    
    const observer = new MutationObserver(() => {
      setTimeout(overrideBackButton, 100);
    });
    
    const waitForPageContent = () => {
      const pageContent = document.querySelector('.page-content');
      if (pageContent) {
        observer.observe(pageContent, { childList: true, subtree: true });
      } else {
        setTimeout(waitForPageContent, 100);
      }
    };
    
    waitForPageContent();
    
    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      padding: '40px 20px',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{ marginBottom: '40px' }}>
        <CanvasesCategoriesTest 
          isDemo={true} 
          submissionUnlocked={false} 
          demoNodes={demoNodes}
        />
      </div>

      <div style={{
        borderRadius: '12px',
        backgroundColor: '#f8f9fa',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        padding: '20px'
      }}>
        <div className="grid-container">
          <Grid className="grid-padding-x">
            <Cell small={12}>
              <div className="canvas-category-controls-and-actions">
                <div className="canvas-category-controls-and-actions-header">
                  <h2 className="canvas-category-controls-and-actions-header__title">
                    Controls and Actions for Work-Life Balance Discussion
                  </h2>
                  <p className="canvas-category-controls-and-actions-header__microcopy">
                    Here are some instructions for what to do with the action checkboxes
                  </p>
                </div>

                <form className="basic-form">
                  <Grid className="canvas-category-controls-and-actions-section-wrap">
                    <Cell
                      small={12}
                      large={6}
                      className="canvas-category-controls-and-actions-section canvas-category-controls-and-actions-section--left"
                    >
                      <div className="canvas-category-controls-and-actions-section__inner">
                        <div className="canvas-category-controls-and-actions-section-item">
                          <div className="canvas-category-controls-and-actions-section-item__title canvas-category-controls-and-actions-section-item__title--control">
                            <span>Control{' '}
                              <span className="canvas-category-control-header-info-icon canvas-category-control-header-info-icon--white" title="Click for more information about Control">
                                <FaInfoCircle size={16} />
                              </span>
                            </span>
                          </div>
                          <div className="canvas-category-controls-and-actions-section-item__styles">
                            <textarea 
                              className="canvas-category-controls-and-actions-section-item__input" 
                              rows="8" 
                              readOnly 
                              style={{ backgroundColor: '#e9ecef', color: '#212529' }}
                              value="Set up weekly 1-on-1 meetings to discuss workload and priorities."
                            />
                          </div>
                        </div>
                      </div>
                    </Cell>

                    <Cell
                      small={12}
                      large={6}
                      className="canvas-category-controls-and-actions-section canvas-category-controls-and-actions-section--right"
                    >
                      <div className="canvas-category-controls-and-actions-section__inner">
                        <div className="canvas-category-controls-and-actions-section-item">
                          <div className="canvas-category-controls-and-actions-section-item__title canvas-category-controls-and-actions-section-item__title--action" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <span>Action{' '}
                              <span className="canvas-category-action-header-info-icon canvas-category-action-header-info-icon--white" title="Click for more information about Action">
                                <FaInfoCircle size={16} />
                              </span>
                            </span>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <label className="custom-checkbox canvas-actions-checkbox">
                                <input 
                                  className="basic-form__input" 
                                  type="checkbox" 
                                  id="action-1"
                                  checked={checkboxStates['action-1'] || false}
                                  onChange={(e) => handleCheckboxChange('action-1', e.target.checked)}
                                />
                                <span className="checkmark"></span>
                              </label>
                            </div>
                          </div>
                          <div className="canvas-category-controls-and-actions-section-item__styles">
                            <textarea 
                              className="canvas-category-controls-and-actions-section-item__input canvas-category-controls-and-actions-section-item__input--action" 
                              rows="3" 
                              readOnly 
                              style={{ backgroundColor: '#e9ecef', color: '#212529' }}
                              value="Schedule a follow-up meeting in 2 weeks to review progress."
                            />
                          </div>
                        </div>

                        <div className="canvas-category-controls-and-actions-section-item">
                          <div className="canvas-category-controls-and-actions-section-item__title canvas-category-controls-and-actions-section-item__title--action" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <span>Action{' '}
                              <span className="canvas-category-action-header-info-icon canvas-category-action-header-info-icon--white" title="Click for more information about Action">
                                <FaInfoCircle size={16} />
                              </span>
                            </span>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <label className="custom-checkbox canvas-actions-checkbox">
                                <input 
                                  className="basic-form__input" 
                                  type="checkbox" 
                                  id="action-2"
                                  checked={checkboxStates['action-2'] || false}
                                  onChange={(e) => handleCheckboxChange('action-2', e.target.checked)}
                                />
                                <span className="checkmark"></span>
                              </label>
                            </div>
                          </div>
                          <div className="canvas-category-controls-and-actions-section-item__styles">
                            <textarea 
                              className="canvas-category-controls-and-actions-section-item__input canvas-category-controls-and-actions-section-item__input--action" 
                              rows="3" 
                              readOnly 
                              style={{ backgroundColor: '#e9ecef', color: '#212529' }}
                              value="Research relevant training courses or workshops."
                            />
                          </div>
                        </div>
                      </div>
                    </Cell>
                  </Grid>
                </form>
              </div>
            </Cell>
          </Grid>
        </div>
      </div>
    </div>
  );
}